module.exports = __webpack_public_path__ + "static/media/finx_kotak_howtogetstarted_new.bbefe300.png";